import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';
import './assets/vendors/styles.css'

// Register service worker
// commit for dev n prod build
registerServiceWorker();

// Render the app directly without React Hot Loader
ReactDOM.render(
  <NextApp />,
  document.getElementById('root')
);
